import React from 'react'
import { Box, CircularProgress, useTheme } from '@mui/material'

const LoadingOverlay: React.FC = () => {
  const theme = useTheme()

  return (
    <Box
      sx={{
        position: 'absolute',
        height: '100%',
        width: '100%',
        borderRadius: 1,
        backgroundColor: 'rgba(175, 175, 175, 0.5)',
        zIndex: theme.zIndex.appBar - 2,
        top: 0,
        left: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <CircularProgress />
    </Box>
  )
}

export default LoadingOverlay
